module.exports = __webpack_public_path__ + "static/media/englishPage4.c4315ea0.jpg";